import { render, staticRenderFns } from "./ListOcorrencias.vue?vue&type=template&id=a6de7004"
import script from "./ListOcorrencias.vue?vue&type=script&lang=js"
export * from "./ListOcorrencias.vue?vue&type=script&lang=js"
import style0 from "./ListOcorrencias.vue?vue&type=style&index=0&id=a6de7004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports